import { c as _c } from "react/compiler-runtime";
import { useParams } from 'next/navigation';
import { useMemo } from 'react';
import { type Address, isAddress } from 'viem';
import { useWeb3Context } from '@/contexts/Web3Context';

/**
 * Hook that determines the viewed account address from URL params or connected wallet.
 * @returns Object with address, whether it's the user's own address, source, and URL address
 */
export function useViewedAccountAddress() {
  const $ = _c(11);
  const {
    account
  } = useWeb3Context();
  const params = useParams();
  const urlAddress = params.address as string | undefined;
  let t0;
  bb0: {
    if (!urlAddress) {
      t0 = account.address ?? undefined;
      break bb0;
    }
    let t1;
    if ($[0] !== urlAddress) {
      t1 = isAddress(urlAddress) ? urlAddress : undefined;
      $[0] = urlAddress;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    t0 = t1;
  }
  const address = t0;
  let t1;
  bb1: {
    if (!account.isConnected || !address || !account.address) {
      t1 = false;
      break bb1;
    }
    let t2;
    if ($[2] !== address) {
      t2 = address.toLowerCase();
      $[2] = address;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== account.address) {
      t3 = account.address.toLowerCase();
      $[4] = account.address;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t1 = t2 === t3;
  }
  const isSelf = t1;
  const source = urlAddress ? "url" : "wallet";
  let t2;
  if ($[6] !== address || $[7] !== isSelf || $[8] !== source || $[9] !== urlAddress) {
    t2 = {
      address,
      isSelf,
      source,
      urlAddress
    };
    $[6] = address;
    $[7] = isSelf;
    $[8] = source;
    $[9] = urlAddress;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}